import styles from 'components/socialIcons/socialIcons.module.css';
import { WhatsAppIcon } from 'components/vectors/socialIcons/WhatsAppIcon';
import { IG } from 'components/vectors/socialIcons/IG';
import { TiktokIcon } from 'components/vectors/socialIcons/Tiktok';
import { WhatsAppIconBlack } from 'components/vectors/socialIcons/WhatsAppIconBlack';
import { TiktokBlack } from 'components/vectors/socialIcons/TiktokBlack';
import { IGBlack } from 'components/vectors/socialIcons/IGBlack';

const listOfSocials = [
    {
        name: 'whatsapp',
        icon: <WhatsAppIcon />,
        iconBlack: <WhatsAppIconBlack />,
        link: 'https://wa.me/+33769715909?text=I%27d%20like%20to%20get%20an%20offer',
    },
    {
        name: 'instagram',
        icon: <IG />,
        iconBlack: <IGBlack />,
        link: 'https://www.instagram.com/lesfemmes.show?igsh=MjFoeDQycnNtaHcx&utm_source=qr',
    },
    {
        name: 'tiktok',
        icon: <TiktokIcon />,
        iconBlack: <TiktokBlack />,
        link: 'https://www.tiktok.com/@lesfemmes.show?_t=ZN-8tdiqqpVTms&_r=1',
    },
];

export const SocialIcons = ({ isBlack }: { isBlack?: boolean }) => {
    return (
        <div className={styles.socialIcons}>
            {listOfSocials.map(({ icon, iconBlack, link, name }) => {
                return (
                    <a
                        key={name}
                        href={link}
                        target="_blank"
                        className={styles.socialIcons__item}
                        rel="noreferrer"
                    >
                        {isBlack ? iconBlack : icon}
                    </a>
                );
            })}
        </div>
    );
};
